import React from 'react'
import Contact_form from '../Components/Contact_form'

function ContactPage() {

  return (
    <div className=''>
      <Contact_form/>
    </div>
  )
}

export default ContactPage
